export const LOGIN_ROUTE = '/login';
export const CREATE_EVENT_ROUTE = '/create-event';
export const CREATE_EVENT_GROUP_ROUTE = '/create-group';
export const EVENTS_LIST_ROUTE = '/events';
// home screen
export const DEFAULT_ROUTE = EVENTS_LIST_ROUTE;

/** Items tab; use {@link getInventoryItemUrl} for deep links to a specific item type. */
export const INVENTORY_ITEMS_ROUTE = '/inventory/items';

/** Query param on {@link INVENTORY_ITEMS_ROUTE} to open the item detail dialog. */
export const INVENTORY_ITEM_QUERY_PARAM = 'item';

export function getInventoryItemUrl(itemTypeId: string): string {
    return `${INVENTORY_ITEMS_ROUTE}?${INVENTORY_ITEM_QUERY_PARAM}=${encodeURIComponent(itemTypeId)}`;
}

export const IMAGE_CACHE_NAME = 'images';
export const IMAGE_UPLOAD_QUEUE_NAME = 'zw-image-upload';
export const IMAGE_UPLOAD_RETRY_EVENT_TYPE = 'replayQueue';

export const PROD_BACKEND_URL = 'https://cf-worker-zw-backend.shannon-665.workers.dev';
export const DEV_BACKEND_URL = 'https://cf-worker-zw-backend-dev.shannon-665.workers.dev';

export const BACKEND_BASE_URL =
    process.env.REACT_APP_BACKEND_BASE_URL || (process.env.REACT_APP_INSTANTDB_ENV === 'production' ? PROD_BACKEND_URL : DEV_BACKEND_URL);

/** Origins we cache images from (dev and prod backends only). */
export const IMAGE_CACHE_ORIGINS = [PROD_BACKEND_URL, DEV_BACKEND_URL];

// instantdb id of latest version record
export const LATEST_VERSION_ID = 'c233b98f-f205-4bca-94d2-d6b7fefa7b8b';
// instantdb id of the single appSettings record (global welcome etc.)
export const APP_SETTINGS_ID = '42e56e40-ceaf-4e0f-ae58-fb0eb7b1e0ed';

// Frontend domain configuration (matches terraform/cloudflare.tf)
export const PROD_DOMAIN = 'app.zerowastefest.com';
export const DEV_DOMAIN = 'app-dev.zerowastefest.com';
